import type {QueryClient, DefaultOptions} from '@tanstack/react-query'

/**
 * Conservative defaults: keep them volatile-safe so that an un-tagged useQuery
 * behaves like before. Stable resources must opt in by setting staleTime
 * explicitly (see front-development-rules.md, "API Caching").
 */
export const defaultQueryClientOptions: DefaultOptions = {
  queries: {
    staleTime: 0,
    gcTime: 5 * 60_000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: 1,
  },
}

let _queryClient: QueryClient | null = null

export const setQueryClient = (client: QueryClient) => {
  _queryClient = client
}

export const getQueryClient = (): QueryClient => {
  if (!_queryClient) {
    throw new Error(
      'QueryClient non initialisé. Appelez setQueryClient dans Root/Auth.',
    )
  }
  return _queryClient
}
